import React, {
	Context,
} from 'react';
import Socket from '../connection/socket';

export interface SocketInterface {
	socket: Socket
}

export const SocketContext = React.createContext({
	socket: null,
}) as unknown as Context<SocketInterface>;

export const SocketProvider = (
	props: any,
): React.ReactElement<any, React.Provider<SocketInterface>> => (
	<SocketContext.Provider value={{ socket: props.socket }}>
		{props.children}
	</SocketContext.Provider>
);
